import { type Provider } from 'react';

import { globalConfig } from './globalConfig';
import type { GlobalConfig } from './types';

export const GlobalConfigProvider: Provider<GlobalConfig> = globalConfig.Provider;
